import { render, staticRenderFns } from "./SettingGeneralReminderModal.vue?vue&type=template&id=28b1e1d4&scoped=true"
import script from "./SettingGeneralReminderModal.vue?vue&type=script&lang=js"
export * from "./SettingGeneralReminderModal.vue?vue&type=script&lang=js"
import style0 from "./SettingGeneralReminderModal.vue?vue&type=style&index=0&id=28b1e1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1e1d4",
  null
  
)

export default component.exports